import _ from 'lodash'
import { d } from 'core/service/lib/decimal'
import riderMessages from 'core/data-model/constants/validation-messages'

export const checkLinkedRidersSumAssuredRule = (rule, eligibilities) => {
  let errorMessage = ''
  let linkedRider = _.find(eligibilities.selectedRiders, { code: rule.linkedRiderCode })
  if (!_.isEmpty(linkedRider)) {
    let combinedSumAssured = d(eligibilities.rider.sumAssured)
      .plus(_.get(linkedRider, 'sumAssured', 0))
      .toNumber()

    if (
      combinedSumAssured >
      Math.min(rule.maximumCombinedSumAssured, eligibilities.basicSumAssured * rule.basicSumAssuredFactor)
    ) {
      let messageId = `RULE_RIDER_LINKED_${eligibilities.rider.code}_${rule.linkedRiderCode}`
      errorMessage = _.get(riderMessages, messageId) || riderMessages.RULE_MESSAGE_NOT_FOUND
    }
  }
  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
